export default "__VITE_ASSET__0AcFiEIQ__"